import { Component } from '@angular/core';
import { Direction } from 'src/app/types/misc/Direction';
import { SHARED_IMPORTS } from 'src/app/utils/other/standalone-import';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-logged-out-layout',
  templateUrl: './logged-out-layout.component.html',
  styleUrls: ['./logged-out-layout.component.scss'],
  standalone: true,
  imports: [SHARED_IMPORTS]
})
export class LoggedOutLayoutComponent {
  /**
   * Is needed to control on which direction the login mask is located.
   */
  style: Direction = 'right';

  constructor() {
    this.style = environment.loggedOutStyle;
  }
}
